<template>
    <div v-scroll="onScroll" class="h-100" v-resize="OnResize">
        <UserNavigationDrawer :showMenu="showMenu" />
        <Header
            v-bind:offsetTop="offsetTop"
            @action="onAction"
            v-if="isPersonalizepage"
        />
        <v-main :class="$vuetify.display.smAndUp ? 'h-100' : 'h-100'">
            <!-- :class="$vuetify.display.smAndUp ? 'h-100' : ''" -->
            <slot></slot>
            <vue-snotify />
        </v-main>
    </div>
</template>

<script>
import UserNavigationDrawer from "@/components/common/UserNavigationDrawer.vue";
import Header from "@/components/layout/header/Header.vue";
import { createHelpers } from "vuex-map-fields";
import { customAttributeValue } from "@/services/util.service";
const fingerprintCookies = import.meta.env.VITE_FINGERPRINT_COOKIES;

const storeFrontUrl = import.meta.env.VITE_APP_CRANE_DAILY_URL;
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
const { mapFields } = createHelpers({
    getterType: "layout/getField",
    mutationType: "layout/updateField",
});

export default {
    name: "BuilderLayout",

    components: {
        Header,
        UserNavigationDrawer,
    },

    data: () => ({
        offsetTop: 0,
        showMenu: false,
        categoryList: [],
        activeMainMenu: "",
        activeSubMenu: "",
        activeSubMenuItem: "",
        search: null,
        searchResultList: [],
        lookupCatelog: null,
        searchInProgress: false,
        pageNo: 1,
        pageSize: 9,
        sortSelect: { label: "Position", value: "position" },
        visitorId: "",
        errorMessage: "",
    }),
    computed: {
        inProgress: function () {
            return this.$store.state.headerCategoryList.inProgress;
        },
        guestQuoteId: function () {
            return this.$store.state.cartProduct.guestQuoteId;
        },
        isDesktop: function () {
            return this.$vuetify.display.xs ? true : false;
        },
        isPersonalizepage: function () {
            let currentPage = this.$route.name;
            if (
                currentPage === "ProductPersonalizeDesignerMode" ||
                currentPage === "ProductPersonalize" ||
                currentPage === "ProductSummary" ||
                currentPage === "ProductSummaryDesignerMode" ||
                currentPage === "PersonalizeSession"
            )
                return false;
            else return true;
        },
        designerModeFlag: function () {
            if (
                this.$route.params.designerMode &&
                this.$route.params.designerMode == "true"
            )
                return true;
            return false;
        },
        userAuth: function () {
            return this.$store.state.auth.userAuth;
        },
        userName: function () {
            return this.$store.state.accountOne.one.firstname;
        },
        basicInfo: function () {
            return this.$store.state.accountOne.one;
        },
        ...mapFields(["user", "user.userVisits"]),
    },
    methods: {
        GotoPage() {
            // this.search = null;
            this.showSearchInput = false;
            this.searchResultList = [];
            let searchKeywords = this.search;
            // let skuNew = seletedData.title;
            window.open(
                `${storeFrontUrl}/search?pageNumber=1&pageSize=9&sortBy=relevance&q=${searchKeywords}&filter=e30=`,
                "_self",
            );
        },
        onScroll() {
            this.offsetTop =
                window.pageYOffset || document.documentElement.scrollTop;
        },
        onAction(action) {
            this.showMenu = action.showMenu;
            this.categoryList = action.categoryList;
        },
        OnResize() {
            setTimeout(() => {
                if (this.$vuetify.display.mdAndUp) {
                    this.showMenu = false;
                }
            }, 200);
        },
        goToLogout() {
            window.open(`${storeFrontUrl}/logout-success`, "_self");
        },
        goToDashboard() {
            window.open(`${storeFrontUrl}/me/account-dashboard`, "_self");
        },
        goToLogin() {
            window.open(`${storeFrontUrl}/gate/sign-in`, "_self");
        },
        goToStoreLocator() {
            window.open(`${storeFrontUrl}/store-locator`, "_self");
        },
        getCustomAttributeValue(customAttributes, attributeCode) {
            return customAttributeValue(customAttributes, attributeCode);
        },
        async fingerprintCode() {
            try {
                let vm = this;
                if (!this.userAuth) {
                    let storedVisitorId = cookies.get(fingerprintCookies);

                    if (storedVisitorId) {
                        this.visitorId = storedVisitorId;
                        if (window) {
                            window.DD_RUM.onReady(function () {
                                window.DD_RUM.setUser({
                                    id: vm.visitorId,
                                });
                            });
                            window.Appcues.identify(vm.visitorId, {
                                fingerprintId: vm.visitorId,
                            });
                        }
                    } else {
                        const visitorData = await this.$fpjs.getVisitorData({
                            extendedResult: true,
                        });

                        if (visitorData) {
                            this.visitorId = visitorData.visitorId;

                            // Store in a cookie (valid for 1 year)
                            cookies.set(
                                fingerprintCookies,
                                this.visitorId,
                                "365d",
                            );
                            if (window) {
                                window.DD_RUM.onReady(function () {
                                    window.DD_RUM.setUser({
                                        id: vm.visitorId,
                                    });
                                });
                                window.Appcues.identify(vm.visitorId, {
                                    fingerprintId: vm.visitorId,
                                });
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("FingerprintJS Pro Error:", error);
                this.errorMessage = error.message;
            }
        },
    },
    async created() {
        const vm = this;
        if (this.userAuth) {
            this.$store.dispatch("userCartProduct/cartProductList");
            this.$store.dispatch("userCartProduct/productTotalAmt");
            await this.$store.dispatch("accountOne/basicInfo");
            const visitorData = await this.$fpjs.getVisitorData({
                extendedResult: true,
            });

            if (visitorData) {
                this.visitorId = visitorData.visitorId;
                if (window) {
                    window.DD_RUM.onReady(function () {
                        window.DD_RUM.setUser({
                            id: vm.visitorId ? vm.visitorId : "",
                            magento_id: vm.basicInfo.id,
                            name: `${vm.basicInfo.firstname} ${vm.basicInfo.lastname}`,
                            email: vm.basicInfo.email,
                        });
                    });
                    window.Appcues.identify(vm.visitorId ? vm.visitorId : "", {
                        fingerprintId: vm.visitorId,
                        magentoId: vm.basicInfo.id,
                        name: `${vm.basicInfo.firstname} ${vm.basicInfo.lastname}`,
                        email: vm.basicInfo.email,
                    });
                }
            }
        } else {
            if (this.guestQuoteId) {
                this.$store.dispatch(
                    "cartProduct/cartProductList",
                    this.guestQuoteId,
                );
                this.$store.dispatch(
                    "cartProduct/productTotalAmt",
                    this.guestQuoteId,
                );
            }
        }
        if (this.userVisits) {
            let userVisits = Number(this.userVisits) + 1;
            localStorage.setItem("cr_craneUserVisitCount", userVisits);
            this.userVisits = userVisits;
        } else {
            localStorage.setItem("cr_craneUserVisitCount", 1);
            this.userVisits = 1;
        }
    },
    async mounted() {
        this.fingerprintCode();
    },
};
</script>
<style lang="scss">
.header-input-custom {
    .v-input__control {
        background-color: transparent !important;
    }
    .v-input__slot {
        &:before {
            border-color: #ffffff !important;
            border-style: solid;
            border-width: 1px;
        }
        &:after {
            border-color: #ffffff !important;
            border-style: solid;
            border-width: 1px;
        }
    }
    .v-text-field__slot {
        input {
            color: #ffffff !important;
            border-bottom-color: #ffffff !important;
        }
        input::placeholder {
            color: #ffffff !important;
        }
        input:-ms-input-placeholder {
            color: #ffffff !important;
        }

        input ::-ms-input-placeholder {
            color: #ffffff !important;
        }
    }
    .v-icon {
        color: #ffffff !important;
    }
    .mobile-header-list.theme--light.v-list {
        background: #2805da;
    }
    .v-list-item__icon {
        color: #ffffff !important;
    }
    .z-index-1000 {
        z-index: 1000 !important;
    }
}
.mobile-header-autocomplete .v-input__append-inner .v-input__icon {
    display: none !important;
}
.mobile-header-autocomplete .theme--light.v-icon {
    color: #ffffff !important;
}
.mobile-header-autocomplete.theme--light.v-input input {
    color: #ffffff !important;
}
.mobile-header-autocomplete.theme--light.v-text-field--filled
    > .v-input__control
    > .v-input__slot {
    background-color: transparent !important;
}
.cursor-pointer {
    cursor: pointer;
}
</style>
<style src="./Layout.scss" lang="scss" />
